import React, { Component } from 'react'
import styled from 'styled-components'
import {
  Header,
  XLText,
  TopSection,
  Button,
  CardWrap,
  ActionCard,
  UserContent,
  Modal,
  PageWrapper,
  FlexWrapper,
  XCMText,
  TextOverflow,
  Footer
} from '../components'
import Cookies from 'js-cookie'
const PageWrap = styled.div`
  padding: 10px 16px 16px;
`
class UserProfile extends Component {
  state = {
    showModal: false,
    comingSoonModel: false
  }
  render() {
    const { showModal, comingSoonModel } = this.state
    return (
      <React.Fragment>
        <Header title={'Profile'} icon="arrowBack" onClickBack={() => this.props.history.goBack()} color="#fff" />
        <PageWrapper viewPadding="22.4% 4.3% 26%" height="auto" modifyPadding="0 0 84px">
          <UserContent onTouch={() => this.props.history.push('/user-profile/edit')} />
          <PageWrap>
            <FlexWrapper width="100%" alignItems="center">
              <XLText textTransform="capitalize">
                <TextOverflow maxWidth="200px">{Cookies.getJSON('userDetails').name.split(' ')[0]}</TextOverflow>
              </XLText>
            </FlexWrapper>
            <TopSection title="Community" padding="30px 0 10px 0" />
            <CardWrap borderBottom="0.5px solid #dcdcdc">
              <ActionCard
                label="Spread the Word"
                icon="spread"
                namespace="Spread the Word"
                // onTouch={() => this.setState({ comingSoonModel: true })}
                onTouch={() => this.props.history.push('/invite')}
              />

              <ActionCard
                label="Nominate a grocery store for listing"
                onTouch={() => this.props.history.push('/nominate-grocery')}
              />
              <ActionCard
                label="Nominate a brand/product for scoring"
                onTouch={() => this.props.history.push('/nominate-brand')}
              />
              <ActionCard
                label="Give Us Feedback"
                icon="feedback"
                onTouch={() => this.props.history.push('/feedback')}
              />
            </CardWrap>
            <TopSection title="Account Preferences" padding="30px 0 10px 0" />
            <CardWrap borderBottom="0.5px solid #dcdcdc">
              <ActionCard
                label="My Values"
                icon="strawberry"
                iconTwo="shield"
                iconThree="environment"
                onTouch={() => this.props.history.push('/dashboard/values/edit')}
              />
              <ActionCard
                label="Dietary Preferences"
                onTouch={() => this.props.history.push('/dashboard/dietary-preference/edit')}
              />
              <ActionCard label="Allergies" onTouch={() => this.props.history.push('/dashboard/allergies/edit')} />
              <ActionCard label="Favorite Grocers" onTouch={() => this.props.history.push('/dashboard/shop/edit')} />
              <ActionCard
                label="Location"
                icon="location"
                onTouch={() => this.props.history.push('/dashboard/zipcode/edit')}
              />
            </CardWrap>
            <TopSection title="More" padding="30px 0 10px 0" />
            <CardWrap borderBottom="0.5px solid #dcdcdc">
              <ActionCard label="About Us" onTouch={() => this.props.history.push('/aboutus')} />
              {/* <ActionCard label="Our Team" onTouch={() => this.props.history.push('/our-team')} /> */}
              <ActionCard label="FAQ" onTouch={() => this.props.history.push('/faq')} />
              <ActionCard label="Privacy Policy" onTouch={() => this.props.history.push('/privacy-policy')} />
            </CardWrap>

            <Button
              label="LOGOUT"
              margin="20px 0 0 0"
              namespace="Logout"
              onClick={() => this.setState({ showModal: true })}
              logout
            />
          </PageWrap>
        </PageWrapper>
        <Modal
          title={'Do you really want to logout?'}
          show={showModal}
          hide={!showModal}
          onClose={() => this.setState({ showModal: false })}>
          <Button
            size="small"
            label="Confirm"
            namespace="Logout"
            volume="filled"
            margin="14px auto 0"
            type="submit"
            onClick={() => {
              Cookies.remove('access_token', { path: '/' })
              Cookies.remove('redirect', { path: '/' })
              Cookies.remove('steps', { path: '/' })
              Cookies.remove('userDetails', { path: '/' })
              Cookies.remove('user_id', { path: '/' })
              Cookies.remove('previousPath', { path: '/' })
              Cookies.remove('currentPage', { path: '/' })
              Cookies.remove('selectedStores', { path: '/' })
              window.location.href = '/auth/social-login'
            }}
          />
        </Modal>
        {/* <Modal title="Coming Soon!" show={comingSoonModel} hide={!comingSoonModel}>
          <FlexWrapper alignItems="center">
            <Button
              label="Close"
              namespace="Spread The Word"
              volume="filled"
              size="small"
              onClick={() => this.setState({ comingSoonModel: false })}
            />
          </FlexWrapper>
        </Modal> */}
        <Modal show={comingSoonModel} hide={!comingSoonModel} onClose={() => this.setState({ comingSoonModel: false })}>
          <FlexWrapper alignItems="center">
            <XCMText>Coming Soon!</XCMText>
          </FlexWrapper>
        </Modal>
        <Footer />
      </React.Fragment>
    )
  }
}

export default UserProfile



// WEBPACK FOOTER //
// ./src/pages/UserProfile.js